import { render, staticRenderFns } from "./ChangelogFilter.vue?vue&type=template&id=5aafb9ef&"
import script from "./ChangelogFilter.vue?vue&type=script&lang=js&"
export * from "./ChangelogFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports